import axios from 'axios'
import store from '../store/index'
import router from '../router'

const axiosApi = axios.interceptors.response.use(response => {
  if (response.data.payload.loggedIn === false && router.currentRoute.fullPath !== '/login') {
    store.dispatch('auth/authLogout')
  }
  return response
})

export default axiosApi



// WEBPACK FOOTER //
// ./src/axios/axiosInterceptors.js